import { signal } from '@preact/signals';

export type Toast = { id: string; text: string; kind: 'info' | 'error'; expiresAt: number };

const MAX_VISIBLE = 3;
const TTL_MS = 3000;

export const toastQueue = signal<Toast[]>([]);

function genId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `t-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function pushToast(text: string, kind: 'info' | 'error' = 'info'): void {
  const t: Toast = { id: genId(), text, kind, expiresAt: Date.now() + TTL_MS };
  const next = [...toastQueue.value, t];
  toastQueue.value = next.length > MAX_VISIBLE ? next.slice(next.length - MAX_VISIBLE) : next;
}

// test-only
export function _resetForTests(): void {
  toastQueue.value = [];
}
